import React from 'react';
import './MyStepIndicator.css';

function StepIndicator({ steps, currentStep }) {
    return (
        <div className="step-indicator">
            {steps.map((step, index) => (
                <div 
                    key={index} 
                    className={`step ${index < currentStep ? 'completed' : ''} ${index === currentStep ? 'current' : ''}`}
                >
                    <div className="step-number">{index + 1}</div>
                    <div className="step-title">{step}</div>
                </div>
            ))}
        </div>
    );
}

export default StepIndicator;